import React, { FC } from 'react';

const Topbar: FC = () => {
  return <div className="d-flex align-items-stretch flex-shrink-0" />; // vacío
};

export { Topbar };
